// extracted by mini-css-extract-plugin
export default {"thumbnail_container":"VideoThumbnail_thumbnail_container__yI35I","thumbnail_image":"VideoThumbnail_thumbnail_image__UVk8P"};